import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-licence-pendding-list',
  templateUrl: './licence-pendding-list.component.html',
  styleUrls: ['./licence-pendding-list.component.css']
})
export class LicencePenddingListComponent implements OnInit {
  title="PSA Licence Pending List";
  toDay ;
  constructor() {    
    this.toDay = new Date();
  }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// ./src/app/pages/view/rpt-form/report-list/licence-pendding-list/licence-pendding-list.component.ts